import { useOktaAuth } from "@okta/okta-react";

const useGetAccessToken = () => {
  const { authState } = useOktaAuth();

  return authState?.isAuthenticated && authState?.accessToken?.accessToken
    ? authState.accessToken.accessToken
    : "";
};

export default useGetAccessToken;
